import SodInsights from './SodInsights';

export type { SodInsightsHandle } from './SodInsights';

export default SodInsights;
